module.exports = __webpack_public_path__ + "4d30c85f1c18a4f3a4746ea18453e894.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/wasistgoldencity3.jpg
// module id = 644
// module chunks = 0